import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OrganizationCreationWizard } from '@/features/organizations/components/wizard/OrganizationCreationWizard';
import { requirePermission } from '@/lib/guards';

const wizardSearchSchema = z.object({
  // step "2" = locations, "3" = users; absent = step 1 (organization).
  step: z.enum(['2', '3']).optional(),
  orgId: z.string().optional(),
});

export const Route = createFileRoute('/_staff/admin/workspace/organizations/new')({
  beforeLoad: () => {
    requirePermission('org:create');
  },
  validateSearch: wizardSearchSchema,
  component: OrganizationCreationWizard,
  staticData: { crumb: 'New' },
});
